if (!customElements.get('newsletter-subscribe-form')) {
  class NewsletterSubscribeForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    handleSubmit(e) {
      // Just visual feedback before Shopify naturally reloads/submits the form
      this.setLoading(true);
    }

    setLoading(loading) {
      if (!this.button) return;
      if (!this.button.dataset.text) {
        this.button.dataset.text = this.button.textContent.trim();
      }
      this.button.disabled = loading;
      this.button.textContent = loading ? '...' : this.button.dataset.text;
    }
  }

  customElements.define('newsletter-subscribe-form', NewsletterSubscribeForm);
}
